module.exports = __webpack_public_path__ + "static/img/nanfang .ec92eda0.png";